import React from 'react';
import {BrowserRouter, Routes, Route} from 'react-router-dom';
import {connect} from 'react-redux';
import axios from 'axios';

// Import Routes all
import {userRoutes, authRoutes} from './routes/allRoutes';

// Import all middleware
import {AuthMiddleware} from './routes/middleware/Authmiddleware';

// layouts Format
import VerticalLayout from './components/VerticalLayout/';
import HorizontalLayout from './components/HorizontalLayout/';
import NonAuthLayout from './components/NonAuthLayout';

// Import scss
import './assets/scss/theme.scss';

const App = (props) => {
  axios.interceptors.response.use(
      (response) => response,
      (error) => {
        if (
          401 === error.response.status &&
        error.config.url !== process.env.REACT_APP_APIURL + 'auth/login'
        ) {
          localStorage.removeItem('authUser');
          window.location = '/login';
        } else {
          return Promise.reject(error);
        }
      },
  );

  function getLayout() {
    switch (props.layout.layoutType) {
      case 'horizontal':
        return HorizontalLayout;
      default:
        return VerticalLayout;
    }
  }

  const Layout = getLayout();

  const NonAuthMiddleware = ({component: Component, layout: Layout}) => (
    <Layout>
      <Component />
    </Layout>
  );

  return (
    <BrowserRouter>
      <Routes>
        {authRoutes.map((route, idx) => (
          <Route
            path={route.path}
            key={idx}
            element={<NonAuthMiddleware component={route.component} layout={NonAuthLayout} />}
          />
        ))}

        {userRoutes.map((route, idx) => (
          <Route
            path={route.path}
            key={idx}
            element={
              <AuthMiddleware
                Layout={Layout}
                component={route.component}
                requiredRoles={route.requiredRoles}
              />
            }
          />
        ))}
      </Routes>
    </BrowserRouter>
  );
};

const mapStateToProps = (state) => ({
  layout: state.Layout,
});

export default connect(mapStateToProps)(App);
